import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import scrollToTopBtn from '../components/scrollToTopBtn';
import selectors from '../globals/selectors';
import page from '../helpers/page';
import addSelect from '../components/select';
import faq from '../components/faq';
import promoCarousel from '../components/promoCarousel';
import articles from '../components/articles';

page(() => {
	addSelect(selectors.index.citySelect);
	addSelect(selectors.index.addressSelect);
	promoCarousel();
	scrollToTopBtn();
	articles();
	faq();
	const swiperOilChangeCars = new Swiper('.oil-change__list-wrapper-cars', {
		slidesPerView: 'auto',
		spaceBetween: 30,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		modules: [Navigation, Pagination, Autoplay],
		navigation: {
			nextEl: '.oil-change__button-cars-next',
			prevEl: '.oil-change__button-cars-prev',
		},
		pagination: {
			el: selectors.oilChangeCarousel.pagination.elementOfFirst,
		},
		loop: true,
	});

	const swiperOilChangeExp = new Swiper('.oil-change__list-wrapper-exp', {
		slidesPerView: 'auto',
		spaceBetween: 30,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		modules: [Navigation, Pagination, Autoplay],
		navigation: {
			nextEl: '.oil-change__button-exp-next',
			prevEl: '.oil-change__button-exp-prev',
		},
		pagination: {
			el: selectors.oilChangeCarousel.pagination.elementOfSecond,
		},
		loop: true,
	});

	const buttonList = document.querySelectorAll('.btn.cars__link.btn--insert-shadow');
	const modalElement = document.querySelector('.modal');
	const modalClose = document.querySelector('.modal__header-close');
	const modal = document.querySelector('.modal');

	buttonList.forEach((item) => {
		item.addEventListener('click', (e) => {
			e.preventDefault();
			e._isModalBtn = true;
			document.body.style.overflow = 'hidden';
			modal.classList.add('modal-is-active');
		});
	});

	modalClose.addEventListener('click', () => {
		modalElement.classList.remove('modal-is-active');
	});

	document.addEventListener('keydown', (evt) => {
		if(modalElement.classList.contains('modal-is-active')){
		  	if(evt.key ==='Escape') {
			modalElement.classList.remove('modal-is-active');
		}
		}
	})

	modalElement.addEventListener('click', (evt) => {
		if (evt.target === evt.currentTarget){
			modalElement.classList.remove('modal-is-active');
		}
	})
});
